<template>
  <div class="module-browser-hint" v-bind="$attrs" v-on="$listeners">
    <div class="hint_bg" />
    <div class="hint_content">
      <!-- <div class="hint_close" @click="closeHint">
        <img class="close_img" src="@/assets/icons/close-gray.svg" />
      </div> -->
      <h1 class="hint_title">瀏覽器選用建議</h1>
      <h2 class="hint_greeting">親愛的貴賓，您好：</h2>
      <p class="hint_context">
        為獲得較佳的瀏覽體驗，建議您使用 Google Chrome、Firefox 或 Microsoft
        Edge 等其他瀏覽器軟體。
      </p>
      <div class="hint_browser">
        <a
          target="_blank"
          href="https://www.google.com/intl/zh-TW/chrome/"
          rel="noreferrer noopenner"
        >
          <img
            class="browser_icon"
            src="@/pages/cathayfitback/assets/icons/google-chrome-browser.svg"
          />
        </a>
        <a
          target="_blank"
          href="https://www.mozilla.org/zh-TW/firefox/new/"
          rel="noreferrer noopenner"
        >
          <img
            class="browser_icon"
            src="@/pages/cathayfitback/assets/icons/firefox-browser.svg"
          />
        </a>
        <a
          target="_blank"
          href="https://www.microsoft.com/zh-tw/edge"
          rel="noreferrer noopenner"
        >
          <img
            class="browser_icon"
            src="@/pages/cathayfitback/assets/icons/edge-browser.svg"
          />
        </a>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "moduleBrowserHint",
  mounted() {
    this.checkIE();
  },
  methods: {
    checkIE() {
      if (
        navigator.userAgent.indexOf("MSIE") > -1 ||
        navigator.userAgent.indexOf("Trident") > -1
      ) {
        this.openHint();
      }
    },
    openHint() {
      document.querySelector("#app").classList.add("hint");
    }
    // closeHint() {
    //   document.querySelector("#app").classList.remove("hint");
    // },
  }
};
</script>

<style lang="scss">
@keyframes fade-in {
  from {
    z-index: -1;
    background-color: rgba($color-white, 0);
    opacity: 0;
  }
  to {
    z-index: $z-index-loading;
    background-color: rgba($color-white, 0.8);
    opacity: 1;
  }
}
@keyframes fade-out {
  from {
    z-index: $z-index-loading;
    background-color: rgba($color-white, 0.8);
    opacity: 1;
  }
  to {
    z-index: -1;
    background-color: rgba($color-white, 0);
    opacity: 0;
  }
}

#app {
  &.hint {
    position: absolute;
    height: 100vh;
    width: 100vw;
    overflow: hidden;
    .module-browser-hint {
      animation: fade-in 0.3s ease-in-out forwards;
    }
  }
  &:not(.hint) {
    .module-browser-hint {
      animation: fade-out 0.3s ease-in-out forwards;
    }
  }
}

.module-browser-hint {
  position: fixed;
  z-index: -1;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  user-select: none;
  .hint_bg {
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
  }
  .hint_content {
    @include padding(24px);
    position: absolute;
    width: calc(100vw - 24px);
    max-width: 500px;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    background: $color-white;
    border-radius: 20px;
    box-shadow: 0px 0px 64px rgba(121, 187, 55, 0.05),
      0px 0px 20px rgba(68, 183, 100, 0.12);
  }
  // .hint_close {
  //   position: absolute;
  //   right: 24px;
  //   top: 30px;
  //   vertical-align: middle;
  // }
  .hint_title {
    @include font-heading("h3");
    @include margin-bottom(18px);
    text-align: center;
    font-weight: 600 !important;
  }
  .hint_greeting {
    @include font-heading("h4");
    @include margin-bottom(12px);
  }
  .hint_context {
    @include font-heading("h6");
  }
  .hint_browser {
    @include margin-top(24px);
    text-align: center;
  }
  .browser_icon {
    @include margin-x(6px);
    width: 48px;
  }
}
</style>
